import {
  type EmptyClientSetting,
  type ClientSetting,
  type SpendConstraint,
  type DataColumn,
} from "@features/mmm/components/explore-budgets/client-setting/types";

export type PartialClientSetting = Pick<
  ClientSetting | EmptyClientSetting,
  "kpi" | "kpi_v2" | "desired_kpi_value" | "spend_constraints"
>;
export const useClientSettingData = (clientSetting?: PartialClientSetting) => {
  const getSpendConstraintFeature = (spendConstraint: SpendConstraint) =>
    spendConstraint.feature_v2;

  const getKpi = (setting?: PartialClientSetting) => {
    if (!setting) {
      return null;
    }

    return setting.kpi_v2;
  };

  const getSpendConstraints = (setting?: PartialClientSetting) => {
    if (!setting) {
      return [];
    }

    const spendConstraints = setting.spend_constraints ?? [];
    return spendConstraints.filter((constraint) => {
      return constraint.feature_v2;
    });
  };

  const getSpendDataColumns = (dataColumns: DataColumn[]) =>
    dataColumns.filter((dataColumn) => dataColumn.is_spend);

  const baseReturnedParams = {
    getSpendConstraintFeature,
    getSpendConstraints,
    getSpendDataColumns,
    getKpi,
    kpi: undefined,
    desiredKpiValue: undefined,
    spendConstraints: [],
  };

  if (!clientSetting) {
    return baseReturnedParams;
  }

  const kpi = getKpi(clientSetting);
  const desiredKpiValue = clientSetting.desired_kpi_value;

  const spendConstraints = getSpendConstraints(clientSetting);

  return { ...baseReturnedParams, kpi, desiredKpiValue, spendConstraints };
};
